import PageConnector from './page.props';
import PageComponent from './page.component';

export default PageConnector(PageComponent);
